import { Button } from "@/components/ui/button";
import { ShieldCheck, ArrowRight, Calendar, MailWarning, Users } from "lucide-react";

export default function Login() {
  const handleLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/dashboard";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div data-testid="login-page" className="min-h-screen grid lg:grid-cols-2 bg-white">
      {/* Left */}
      <div className="relative flex flex-col justify-between p-10 lg:p-14 border-r border-slate-200">
        <div className="flex items-center gap-3">
          <img
            src="https://customer-assets-4nw71qhi.emergentagent.net/job_taxegy-practice/artifacts/b8tuv913_Taxegy%20PM%20Logo.png"
            alt="Taxegy Practice Manager"
            className="h-9 w-9 rounded-md object-contain"
            data-testid="login-logo"
          />
          <div>
            <div className="font-heading text-lg font-semibold tracking-tight text-slate-900">Taxegy</div>
            <div className="text-xs uppercase tracking-[0.14em] text-slate-500 font-semibold">Practice Manager</div>
          </div>
        </div>

        <div className="max-w-lg space-y-8">
          <div>
            <h1 className="font-heading text-4xl md:text-5xl font-bold tracking-tight text-slate-900">
              A calmer way to run a UK accountancy practice.
            </h1>
            <p className="mt-4 text-base text-slate-600 leading-relaxed">
              Track clients, deadlines and internal deadline reminders in one professional workspace &mdash; reminders come to you,
              not to your clients, so you stay in control of every filing.
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
            {[
              { icon: Users, label: "Clients & contacts" },
              { icon: Calendar, label: "Recurring jobs" },
              { icon: MailWarning, label: "Internal reminders" },
            ].map(({ icon: I, label }) => (
              <div key={label} className="border border-slate-200 rounded-md p-3 flex items-center gap-2 bg-slate-50/60">
                <I className="h-4 w-4 text-slate-700" />
                <span className="text-sm text-slate-700">{label}</span>
              </div>
            ))}
          </div>

          <Button
            data-testid="login-google-btn"
            onClick={handleLogin}
            size="lg"
            className="rounded-md bg-slate-900 hover:bg-slate-800 text-white transition-colors duration-150"
          >
            Sign in with Google
            <ArrowRight className="ml-2 h-4 w-4" />
          </Button>
        </div>

        <div className="text-xs text-slate-500">
          Secured by Google Sign-in · Timestamps stored in UTC, displayed in Europe/London.
        </div>
      </div>

      {/* Right — visual */}
      <div className="relative hidden lg:block bg-slate-900 tx-grid overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-tr from-slate-900 via-slate-900 to-transparent" />
        <div className="absolute inset-0 p-14 flex flex-col justify-end">
          <div className="max-w-md space-y-4">
            <div className="text-xs uppercase tracking-[0.18em] text-slate-400 font-semibold">Solo. Scalable. Safe.</div>
            <div className="font-heading text-3xl text-white font-semibold leading-tight">
              Built for the sole practitioner scaling toward 250 clients &mdash; without missing a single Companies House filing.
            </div>
            <div className="grid grid-cols-3 gap-4 pt-6">
              {[
                { k: "250", v: "Client capacity" },
                { k: "UTC", v: "Data storage" },
                { k: "UK", v: "Deadline logic" },
              ].map((x) => (
                <div key={x.k} className="border border-slate-700 rounded-md p-3">
                  <div className="font-mono text-2xl text-white">{x.k}</div>
                  <div className="text-xs text-slate-400 mt-1">{x.v}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
